import { useTranslation } from "react-i18next";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { InfoAccordionRow, InfoRowNested } from "./infoCard";
import { getFullName } from "./expeditionDetail.utils";

export const RecipientAccordion = ({
  expedition,
}: {
  expedition: GetOneExpeditionBoResponseDto;
}) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const delivery = expedition.deliveryInfo;
  const fullName = getFullName(delivery?.firstName, delivery?.lastName);
  const recipientLabel =
    delivery?.company && fullName
      ? `${delivery.company} (${fullName})`
      : delivery?.company || fullName || null;

  return (
    <InfoAccordionRow label={t("expeditionDrawerDetails.recipient")} value={recipientLabel}>
      {delivery && (
        <>
          {(delivery.company || fullName) && (
            <InfoRowNested
              label={t("expeditionDrawerDetails.name")}
              value={[delivery.company, fullName].filter(Boolean).join(" — ")}
            />
          )}
          {delivery.street && (
            <InfoRowNested label={t("expeditionDrawerDetails.address")} value={delivery.street} />
          )}
          {delivery.additionalInfo && (
            <InfoRowNested
              label={t("expeditionDrawerDetails.additionalInfo")}
              value={delivery.additionalInfo}
            />
          )}
          <InfoRowNested
            label={t("expeditionDrawerDetails.city")}
            value={[delivery.postalCode, delivery.city].filter(Boolean).join(" ")}
          />
          <InfoRowNested
            label={t("expeditionDrawerDetails.country")}
            value={[delivery.state, delivery.country].filter(Boolean).join(", ")}
          />
          {delivery.phone && (
            <InfoRowNested label={t("expeditionDrawerDetails.phone")} value={delivery.phone} />
          )}
          {delivery.email && (
            <InfoRowNested label={t("expeditionDrawerDetails.email")} value={delivery.email} />
          )}
        </>
      )}
    </InfoAccordionRow>
  );
};
